import App from "modujs";
import modules from "./modules.js";
import replaceCmsVariables from "./modules/ReplaceCmsVariables.js";

const app = new App({ modules });

if (typeof window !== "undefined") {
  window.__modujsApp = app;
}

const onVideoPreviewClick = (event) => {
  const trigger = event.target.closest('[data-video-preview-trigger]');
  if (!trigger) {
    return;
  }

  const container = trigger.closest('[data-video-modal]');
  if (!container || container.dataset.videoModalReady === 'true') {
    return;
  }

  container.dataset.videoPendingOpen = 'true';
};

const init = () => {
  replaceCmsVariables();
  document.addEventListener('click', onVideoPreviewClick);
  app.init(app);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

export default app;
